{
    "app": {
        "name": "بنك التنمية — تجربة العملاء",
        "short_name": "تجربة العملاء",
        "loading": "جارٍ التحميل",
        "tagline": "عميل واحد. سجل واحد. حوار واحد."
    },
    "actions": {
        "save": "حفظ",
        "save_changes": "حفظ التغييرات",
        "cancel": "إلغاء",
        "close": "إغلاق",
        "create": "إنشاء",
        "edit": "تعديل",
        "delete": "حذف",
        "remove": "إزالة",
        "search": "بحث",
        "filter": "تصفية",
        "filters": "عوامل التصفية",
        "clear": "مسح",
        "clear_filters": "مسح عوامل التصفية",
        "apply": "تطبيق",
        "reset": "إعادة تعيين",
        "export": "تصدير",
        "export_csv": "تصدير بصيغة CSV",
        "export_excel": "تصدير بصيغة Excel",
        "export_pdf": "تصدير بصيغة PDF",
        "refresh": "تحديث",
        "retry": "إعادة المحاولة",
        "back": "رجوع",
        "next": "التالي",
        "previous": "السابق",
        "confirm": "تأكيد",
        "view": "عرض",
        "view_all": "عرض الكل",
        "select_all": "تحديد الكل",
        "upload": "رفع",
        "download": "تنزيل",
        "copy": "نسخ",
        "copied": "تم النسخ",
        "show": "إظهار",
        "hide": "إخفاء",
        "reveal": "كشف",
        "more": "المزيد",
        "actions": "إجراءات",
        "all": "الكل"
    },
    "state": {
        "loading": "جارٍ التحميل…",
        "saving": "جارٍ الحفظ…",
        "empty_title": "لا توجد بيانات لعرضها",
        "empty_description": "لا توجد سجلات مطابقة لعوامل التصفية المحددة.",
        "empty_no_filters": "لا يوجد شيء هنا بعد.",
        "error_title": "حدث خطأ ما",
        "error_description": "تعذر تحميل هذه البيانات. يُرجى المحاولة مرة أخرى.",
        "offline": "يبدو أنك غير متصل بالإنترنت.",
        "no_results": "لا توجد نتائج",
        "no_results_for": "لا توجد نتائج لـ «{{query}}»",
        "unauthorised_title": "ليست لديك صلاحية الوصول",
        "unauthorised_description": "يُرجى التواصل مع مسؤول النظام إذا كنت ترى أن هذا خطأ."
    },
    "table": {
        "showing": "عرض {{from}}–{{to}} من {{total}}",
        "per_page": "لكل صفحة",
        "page": "صفحة",
        "of_pages": "من {{total}}",
        "selected_zero": "لم يتم تحديد أي عنصر",
        "selected_one": "تم تحديد عنصر واحد",
        "selected_two": "تم تحديد عنصرين",
        "selected_few": "تم تحديد {{count}} عناصر",
        "selected_many": "تم تحديد {{count}} عنصرًا",
        "selected_other": "تم تحديد {{count}} عنصر",
        "sort_ascending": "ترتيب تصاعدي",
        "sort_descending": "ترتيب تنازلي",
        "columns": "الأعمدة",
        "density": "كثافة العرض",
        "bulk_actions": "إجراءات جماعية"
    },
    "time": {
        "just_now": "الآن",
        "today": "اليوم",
        "yesterday": "أمس",
        "tomorrow": "غدًا",
        "this_week": "هذا الأسبوع",
        "last_7_days": "آخر ٧ أيام",
        "last_30_days": "آخر ٣٠ يومًا",
        "this_month": "هذا الشهر",
        "last_month": "الشهر الماضي",
        "this_quarter": "هذا الربع",
        "this_year": "هذه السنة",
        "custom_range": "نطاق مخصص",
        "from": "من",
        "to": "إلى",
        "hijri": "هجري",
        "gregorian": "ميلادي"
    },
    "language": {
        "label": "اللغة",
        "arabic": "العربية",
        "english": "English",
        "switch_to_arabic": "التبديل إلى العربية",
        "switch_to_english": "Switch to English"
    },
    "theme": {
        "label": "المظهر",
        "light": "فاتح",
        "dark": "داكن",
        "system": "حسب النظام"
    },
    "masked": {
        "hidden": "مخفي لحماية الخصوصية",
        "reveal_prompt": "هل تريد كشف هذه القيمة؟",
        "reveal_warning": "يُسجَّل كشف البيانات الحساسة في سجل التدقيق باسمك.",
        "reveal_reason": "السبب (اختياري)"
    },
    "units": {
        "minutes": "دقيقة",
        "seconds": "ثانية",
        "hours": "ساعة",
        "days": "يوم",
        "currency_omr": "ر.ع."
    },
    "days": {
        "sunday": "الأحد",
        "monday": "الاثنين",
        "tuesday": "الثلاثاء",
        "wednesday": "الأربعاء",
        "thursday": "الخميس",
        "friday": "الجمعة",
        "saturday": "السبت"
    },
    "boolean": {
        "yes": "نعم",
        "no": "لا"
    },
    "priority": {
        "low": "منخفضة",
        "medium": "متوسطة",
        "high": "عالية",
        "critical": "حرجة"
    }
}
